import Resource from "../../slices/amenities/resource/Resource"
import Booking from "../../slices/amenities/booking/Booking"

const amenitiesReducer = {
    resource: Resource,
    booking: Booking,
}

export default amenitiesReducer;